import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class JwtTokenService {

	getToken(): String {
		return window.localStorage['jwtToken'];
	}

	getRefreshToken(): String {
		return window.localStorage['refresh_token'];
	}

	saveRefreshToken(token: String) {
		window.localStorage['refresh_token'] = token;
	}

	saveToken(token: String) {
		window.localStorage['jwtToken'] = token;
	}

	destroyToken() {
		window.localStorage.removeItem('jwtToken');
		window.localStorage.removeItem('refresh_token');
	}
}
